import Cookies from 'js-cookie';

export default function getRewardfulReferral() {
  if (typeof window === 'undefined') return;

  if (window.Rewardful && window.Rewardful.tracked && window.Rewardful.referral) {
    return window.Rewardful.referral;
  }

  // rw.js loads asynchronously, so fall back to the first-party cookie it
  // shares across subdomains in case it hasn't initialized yet
  return getRewardfulReferralFromCookie();
}

function getRewardfulReferralFromCookie() {
  const cookieValue = Cookies.get('rewardful.referral');

  if (!cookieValue) return;

  try {
    const referral = JSON.parse(cookieValue);
    return referral.id || undefined;
  } catch (error) {
    return;
  }
}
